(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("DPlayer", [], factory);
	else if(typeof exports === 'object')
		exports["DPlayer"] = factory();
	else
		root["DPlayer"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = {
    secondToTime: function secondToTime(second) {
        var add0 = function add0(num) {
            return num < 10 ? '0' + num : '' + num;
        };
        var min = parseInt(second / 60);
        var sec = parseInt(second - min * 60);
        return add0(min) + ':' + add0(sec);
    },
    getElementViewLeft: function getElementViewLeft(element) {
        var actualLeft = element.offsetLeft;
        var current = element.offsetParent;
        var elementScrollLeft = document.body.scrollLeft + document.documentElement.scrollLeft;
        if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement) {
            while (current !== null) {
                actualLeft += current.offsetLeft;
                current = current.offsetParent;
            }
        } else {
            while (current !== null && current !== element) {
                actualLeft += current.offsetLeft;
                current = current.offsetParent;
            }
        }
        return actualLeft - elementScrollLeft;
    },
    getScrollPosition: function getScrollPosition() {
        return {
            left: window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0,
            top: window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
        };
    },
    setScrollPosition: function setScrollPosition(_ref) {
        var _ref$left = _ref.left, left = _ref$left === undefined ? 0 : _ref$left, _ref$top = _ref.top, top = _ref$top === undefined ? 0 : _ref$top;
        if (this.isFirefox) {
            document.documentElement.scrollLeft = left;
            document.documentElement.scrollTop = top;
        } else {
            window.scrollTo(left, top);
        }
    },
    isMobile: /mobile/i.test(window.navigator.userAgent),
    isFirefox: /firefox/i.test(window.navigator.userAgent),
    isChrome: /chrome/i.test(window.navigator.userAgent),
    storage: {
        set: function set(key, value) {
            localStorage.setItem(key, value);
        },
        get: function get(key) {
            return localStorage.getItem(key);
        }
    }
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

console.log('\n' + ' %c DPlayer ' + "1.17.2" + ' ' + "4c587e5" + ' %c http://dplayer.js.org ' + '\n' + '\n', 'color: #fadfa3; background: #030307; padding:5px 0;', 'background: #fadfa3; padding:5px 0;');
module.exports = __webpack_require__(2);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor)
                descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
__webpack_require__(3);
var _utils = __webpack_require__(0);
var _utils2 = _interopRequireDefault(_utils);
var _options = __webpack_require__(4);
var _options2 = _interopRequireDefault(_options);
var _i18n = __webpack_require__(6);
var _i18n2 = _interopRequireDefault(_i18n);
var _template = __webpack_require__(7);
var _template2 = _interopRequireDefault(_template);
var _svg = __webpack_require__(8);
var _svg2 = _interopRequireDefault(_svg);
var _danmaku = __webpack_require__(9);
var _danmaku2 = _interopRequireDefault(_danmaku);
var _thumbnails = __webpack_require__(10);
var _thumbnails2 = _interopRequireDefault(_thumbnails);
var _events = __webpack_require__(11);
var _events2 = _interopRequireDefault(_events);
var _fullscreen = __webpack_require__(12);
var _fullscreen2 = _interopRequireDefault(_fullscreen);
var _user = __webpack_require__(13);
var _user2 = _interopRequireDefault(_user);
var _subtitle = __webpack_require__(14);
var _subtitle2 = _interopRequireDefault(_subtitle);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
var index = 0;
var instances = [];
var DPlayer = function () {
    function DPlayer(options) {
        var _this = this;
        _classCallCheck(this, DPlayer);
        this.options = (0, _options2.default)(options);
        this.options.container.classList.add('dplayer');
        if (this.options.video.quality) {
            this.qualityIndex = this.options.video.defaultQuality;
            this.quality = this.options.video.quality[this.options.video.defaultQuality];
        }
        this.tran = new _i18n2.default(this.options.lang).tran;
        this.icons = new _svg2.default(this.options);
        this.events = new _events2.default();
        this.user = new _user2.default(this);
        this.container = this.options.container;
        if (!this.options.danmaku) {
            this.container.classList.add('dplayer-no-danmaku');
        }
        if (this.options.live) {
            this.container.classList.add('dplayer-live');
        }
        if (_utils.isMobile) {
            this.container.classList.add('dplayer-mobile');
        }
        this.template = new _template2.default({
            container: this.container,
            options: this.options,
            index: index,
            tran: this.tran,
            icons: this.icons
        });
        var bar = {};
        bar.volumeBar = this.template.volumeBar;
        bar.playedBar = this.template.playedBar;
        bar.loadedBar = this.template.loadedBar;
        var barWidth = void 0;
        this.updateBar = function (type, percentage, direction) {
            percentage = percentage > 0 ? percentage : 0;
            percentage = percentage < 1 ? percentage : 1;
            bar[type + 'Bar'].style[direction] = percentage * 100 + '%';
        };
        document.addEventListener('click', function () {
            _this.focus = false;
        }, true);
        this.container.addEventListener('click', function () {
            _this.focus = true;
        }, true);
        if (this.options.danmaku) {
            this.danmaku = new _danmaku2.default({
                container: this.template.danmaku,
                opacity: this.user.get('opacity'),
                callback: function callback() {
                    setTimeout(function () {
                        _this.template.danmakuLoading.style.display = 'none';
                        if (_this.options.autoplay && !_utils.isMobile) {
                            _this.play();
                        } else if (_utils.isMobile) {
                            _this.pause();
                        }
                    }, 0);
                },
                error: function error(msg) {
                    _this.notice(msg);
                },
                apiBackend: this.options.apiBackend,
                borderColor: this.options.theme,
                height: this.arrow ? 24 : 30,
                time: function time() {
                    return _this.video.currentTime;
                },
                unlimited: this.user.get('unlimited'),
                api: {
                    id: this.options.danmaku.id,
                    address: this.options.danmaku.api,
                    token: this.options.danmaku.token,
                    maximum: this.options.danmaku.maximum,
                    addition: this.options.danmaku.addition,
                    user: this.options.danmaku.user
                },
                events: this.events
            });
        }
        this.arrow = this.container.offsetWidth <= 500;
        if (this.arrow) {
            var arrowStyle = document.createElement('style');
            arrowStyle.innerHTML = '.dplayer .dplayer-danmaku{font-size:18px}';
            document.head.appendChild(arrowStyle);
        }
        this.video = this.template.video;
        this.template.bezel.addEventListener('animationend', function () {
            _this.template.bezel.classList.remove('dplayer-bezel-transition');
        });
        this.paused = true;
        this.template.playButton.addEventListener('click', function () {
            _this.toggle();
        });
        if (!_utils.isMobile) {
            this.template.videoWrap.addEventListener('click', function () {
                _this.toggle();
            });
            this.template.controllerMask.addEventListener('click', function () {
                _this.toggle();
            });
        } else {
            var toggleController = function toggleController() {
                if (_this.container.classList.contains('dplayer-hide-controller')) {
                    _this.container.classList.remove('dplayer-hide-controller');
                } else {
                    _this.container.classList.add('dplayer-hide-controller');
                }
            };
            this.template.videoWrap.addEventListener('click', toggleController);
            this.template.controllerMask.addEventListener('click', toggleController);
        }
        var lastPlayPos = 0;
        var currentPlayPos = 0;
        var bufferingDetected = false;
        window.requestAnimationFrame = function () {
            return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
                window.setTimeout(callback, 1000 / 60);
            };
        }();
        var setCheckLoadingTime = function setCheckLoadingTime() {
            _this.checkLoading = setInterval(function () {
                currentPlayPos = _this.video.currentTime;
                if (!bufferingDetected && currentPlayPos === lastPlayPos && !_this.video.paused) {
                    _this.container.classList.add('dplayer-loading');
                    bufferingDetected = true;
                }
                if (bufferingDetected && currentPlayPos > lastPlayPos && !_this.video.paused) {
                    _this.container.classList.remove('dplayer-loading');
                    bufferingDetected = false;
                }
                lastPlayPos = currentPlayPos;
            }, 100);
        };
        var clearCheckLoadingTime = function clearCheckLoadingTime() {
            clearInterval(_this.checkLoading);
        };
        this.playedTime = false;
        this.animationFrame = function () {
            if (_this.playedTime) {
                _this.updateBar('played', _this.video.currentTime / _this.video.duration, 'width');
                _this.template.ptime.innerHTML = _utils2.default.secondToTime(_this.video.currentTime);
            }
            window.requestAnimationFrame(_this.animationFrame);
        };
        window.requestAnimationFrame(this.animationFrame);
        this.setTime = function (type) {
            if (!type) {
                _this.playedTime = true;
                setCheckLoadingTime();
            } else {
                _this[type + 'Time'] = true;
                if (type === 'played') {
                    setCheckLoadingTime();
                }
            }
        };
        this.clearTime = function (type) {
            if (!type) {
                _this.playedTime = false;
                clearCheckLoadingTime();
            } else {
                _this[type + 'Time'] = false;
                if (type === 'played') {
                    clearCheckLoadingTime();
                }
            }
        };
        if (this.options.video.thumbnails) {
            this.initThumbnails();
        }
        this.isTimeTipsShow = true;
        this.mouseHandler = this.mouseHandler(this.template.playedBarWrap, this.template.playedBarTime).bind(this);
        this.template.playedBarWrap.addEventListener('mousemove', this.mouseHandler);
        this.template.playedBarWrap.addEventListener('mouseenter', this.mouseHandler);
        this.template.playedBarWrap.addEventListener('mouseleave', this.mouseHandler);
        var thumbMove = function thumbMove(e) {
            var percentage = (e.clientX - _utils2.default.getElementViewLeft(_this.template.playedBarWrap)) / barWidth;
            percentage = percentage > 0 ? percentage : 0;
            percentage = percentage < 1 ? percentage : 1;
            _this.updateBar('played', percentage, 'width');
            _this.template.ptime.innerHTML = _utils2.default.secondToTime(percentage * _this.video.duration);
        };
        var thumbUp = function thumbUp(e) {
            document.removeEventListener('mouseup', thumbUp);
            document.removeEventListener('mousemove', thumbMove);
            var percentage = (e.clientX - _utils2.default.getElementViewLeft(_this.template.playedBarWrap)) / barWidth;
            percentage = percentage > 0 ? percentage : 0;
            percentage = percentage < 1 ? percentage : 1;
            _this.updateBar('played', percentage, 'width');
            _this.seek(parseFloat(bar.playedBar.style.width) / 100 * _this.video.duration);
            _this.setTime();
        };
        this.template.playedBarWrap.addEventListener('mousedown', function () {
            barWidth = _this.template.playedBarWrap.clientWidth;
            _this.clearTime();
            document.addEventListener('mousemove', thumbMove);
            document.addEventListener('mouseup', thumbUp);
        });
        var vWidth = 35;
        this.switchVolumeIcon = function () {
            if (_this.volume() >= 0.95) {
                _this.template.volumeIcon.innerHTML = _this.icons.get('volume-up');
            } else if (_this.volume() > 0) {
                _this.template.volumeIcon.innerHTML = _this.icons.get('volume-down');
            } else {
                _this.template.volumeIcon.innerHTML = _this.icons.get('volume-off');
            }
        };
        var volumeMove = function volumeMove(event) {
            var e = event || window.event;
            var percentage = (e.clientX - _utils2.default.getElementViewLeft(_this.template.volumeBarWrap) - 5.5) / vWidth;
            _this.volume(percentage);
        };
        var volumeUp = function volumeUp() {
            document.removeEventListener('mouseup', volumeUp);
            document.removeEventListener('mousemove', volumeMove);
            _this.template.volumeButton.classList.remove('dplayer-volume-active');
        };
        this.template.volumeBarWrapWrap.addEventListener('click', function (event) {
            var e = event || window.event;
            var percentage = (e.clientX - _utils2.default.getElementViewLeft(_this.template.volumeBarWrap) - 5.5) / vWidth;
            _this.volume(percentage);
        });
        this.template.volumeBarWrapWrap.addEventListener('mousedown', function () {
            document.addEventListener('mousemove', volumeMove);
            document.addEventListener('mouseup', volumeUp);
            _this.template.volumeButton.classList.add('dplayer-volume-active');
        });
        this.template.volumeIcon.addEventListener('click', function () {
            if (_this.video.muted) {
                _this.video.muted = false;
                _this.switchVolumeIcon();
                _this.updateBar('volume', _this.volume(), 'width');
            } else {
                _this.video.muted = true;
                _this.template.volumeIcon.innerHTML = _this.icons.get('volume-off');
                _this.updateBar('volume', 0, 'width');
            }
        });
        this.hideTime = 0;
        var hideController = function hideController() {
            _this.container.classList.remove('dplayer-hide-controller');
            clearTimeout(_this.hideTime);
            _this.hideTime = setTimeout(function () {
                if (_this.video.played.length && !_this.disableHideController) {
                    _this.container.classList.add('dplayer-hide-controller');
                    closeSetting();
                    closeComment();
                }
            }, 2000);
        };
        if (!_utils.isMobile) {
            this.container.addEventListener('mousemove', hideController);
            this.container.addEventListener('click', hideController);
        }
        var closeSetting = function closeSetting() {
            if (_this.template.settingBox.classList.contains('dplayer-setting-box-open')) {
                _this.template.settingBox.classList.remove('dplayer-setting-box-open');
                _this.template.mask.classList.remove('dplayer-mask-show');
                setTimeout(function () {
                    _this.template.settingBox.classList.remove('dplayer-setting-box-narrow');
                    _this.template.settingBox.classList.remove('dplayer-setting-box-speed');
                }, 300);
            }
            _this.disableHideController = false;
        };
        var openSetting = function openSetting() {
            _this.disableHideController = true;
            _this.template.settingBox.classList.add('dplayer-setting-box-open');
            _this.template.mask.classList.add('dplayer-mask-show');
        };
        this.template.mask.addEventListener('click', function () {
            closeSetting();
        });
        this.template.settingButton.addEventListener('click', function () {
            openSetting();
        });
        this.loop = this.options.loop;
        var showdan = this.user.get('danmaku');
        if (!showdan) {
            this.danmaku && this.danmaku.hide();
        }
        var unlimitDan = this.user.get('unlimited');
        this.template.loopToggle.checked = this.loop;
        this.template.loop.addEventListener('click', function () {
            _this.template.loopToggle.checked = !_this.template.loopToggle.checked;
            if (_this.template.loopToggle.checked) {
                _this.loop = true;
            } else {
                _this.loop = false;
            }
            closeSetting();
        });
        this.template.showDanmakuToggle.checked = showdan;
        this.template.showDanmaku.addEventListener('click', function () {
            _this.template.showDanmakuToggle.checked = !_this.template.showDanmakuToggle.checked;
            if (_this.template.showDanmakuToggle.checked) {
                showdan = true;
                if (!_this.paused) {
                    _this.danmaku.show();
                }
            } else {
                showdan = false;
                _this.danmaku.hide();
            }
            _this.user.set('danmaku', showdan ? 1 : 0);
            closeSetting();
        });
        this.template.unlimitDanmakuToggle.checked = unlimitDan;
        this.template.unlimitDanmaku.addEventListener('click', function () {
            _this.template.unlimitDanmakuToggle.checked = !_this.template.unlimitDanmakuToggle.checked;
            if (_this.template.unlimitDanmakuToggle.checked) {
                unlimitDan = true;
                _this.danmaku.unlimit(true);
            } else {
                unlimitDan = false;
                _this.danmaku.unlimit(false);
            }
            _this.user.set('unlimited', unlimitDan ? 1 : 0);
            closeSetting();
        });
        this.template.speed.addEventListener('click', function () {
            _this.template.settingBox.classList.add('dplayer-setting-box-narrow');
            _this.template.settingBox.classList.add('dplayer-setting-box-speed');
            var _loop = function _loop(i) {
                _this.template.speedItem[i].addEventListener('click', function () {
                    _this.video.playbackRate = _this.template.speedItem[i].dataset.speed;
                    closeSetting();
                });
            };
            for (var i = 0; i < _this.template.speedItem.length; i++) {
                _loop(i);
            }
        });
        if (this.danmaku) {
            bar.danmakuBar = this.template.danmakuOpacityBar;
            var dWidth = 130;
            this.on('danmaku_opacity', function (percentage) {
                _this.updateBar('danmaku', percentage, 'width');
                _this.user.set('opacity', percentage);
            });
            this.danmaku.opacity(this.user.get('opacity'));
            var danmakuMove = function danmakuMove(event) {
                var e = event || window.event;
                var percentage = (e.clientX - _utils2.default.getElementViewLeft(_this.template.danmakuOpacityBarWrap)) / dWidth;
                percentage = percentage > 0 ? percentage : 0;
                percentage = percentage < 1 ? percentage : 1;
                _this.danmaku.opacity(percentage);
            };
            var danmakuUp = function danmakuUp() {
                document.removeEventListener('mouseup', danmakuUp);
                document.removeEventListener('mousemove', danmakuMove);
                _this.template.danmakuOpacityBox.classList.remove('dplayer-setting-danmaku-active');
            };
            this.template.danmakuOpacityBarWrapWrap.addEventListener('click', function (event) {
                var e = event || window.event;
                var percentage = (e.clientX - _utils2.default.getElementViewLeft(_this.template.danmakuOpacityBarWrap)) / dWidth;
                percentage = percentage > 0 ? percentage : 0;
                percentage = percentage < 1 ? percentage : 1;
                _this.danmaku.opacity(percentage);
            });
            this.template.danmakuOpacityBarWrapWrap.addEventListener('mousedown', function () {
                document.addEventListener('mousemove', danmakuMove);
                document.addEventListener('mouseup', danmakuUp);
                _this.template.danmakuOpacityBox.classList.add('dplayer-setting-danmaku-active');
            });
        }
        if (this.video.duration !== 1) {
            this.template.dtime.innerHTML = this.video.duration ? _utils2.default.secondToTime(this.video.duration) : '00:00';
        }
        if (!this.danmaku) {
            if (this.options.autoplay && !_utils.isMobile) {
                this.play();
            } else if (_utils.isMobile) {
                this.pause();
            }
        }
        var closeCommentSetting = function closeCommentSetting() {
            if (_this.template.commentSettingBox.classList.contains('dplayer-comment-setting-open')) {
                _this.template.commentSettingBox.classList.remove('dplayer-comment-setting-open');
            }
        };
        var toggleCommentSetting = function toggleCommentSetting() {
            if (_this.template.commentSettingBox.classList.contains('dplayer-comment-setting-open')) {
                _this.template.commentSettingBox.classList.remove('dplayer-comment-setting-open');
            } else {
                _this.template.commentSettingBox.classList.add('dplayer-comment-setting-open');
            }
        };
        var closeComment = function closeComment() {
            if (!_this.template.controller.classList.contains('dplayer-controller-comment')) {
                return;
            }
            _this.template.controller.classList.remove('dplayer-controller-comment');
            _this.template.mask.classList.remove('dplayer-mask-show');
            _this.container.classList.remove('dplayer-show-controller');
            closeCommentSetting();
            _this.disableHideController = false;
        };
        var openComment = function openComment() {
            _this.disableHideController = true;
            if (!_this.template.controller.classList.contains('dplayer-controller-comment')) {
                _this.template.controller.classList.add('dplayer-controller-comment');
                _this.template.mask.classList.add('dplayer-mask-show');
                _this.container.classList.add('dplayer-show-controller');
                _this.template.commentInput.focus();
            }
        };
        this.template.mask.addEventListener('click', function () {
            closeComment();
        });
        this.template.commentButton.addEventListener('click', function () {
            openComment();
        });
        this.template.commentSettingButton.addEventListener('click', function () {
            toggleCommentSetting();
        });
        this.template.commentColorSettingBox.addEventListener('click', function () {
            var sele = _this.template.commentColorSettingBox.querySelector('input:checked+span');
            if (sele) {
                var color = _this.template.commentColorSettingBox.querySelector('input:checked').value;
                _this.template.commentSettingFill.style.fill = color;
                _this.template.commentInput.style.color = color;
                _this.template.commentSendFill.style.fill = color;
            }
        });
        var sendComment = function sendComment() {
            _this.template.commentInput.blur();
            if (!_this.template.commentInput.value.replace(/^\s+|\s+$/g, '')) {
                _this.notice(_this.tran('Please input danmaku content!'));
                return;
            }
            _this.danmaku.send({
                text: _this.template.commentInput.value,
                color: _this.container.querySelector('.dplayer-comment-setting-color input:checked').value,
                type: _this.container.querySelector('.dplayer-comment-setting-type input:checked').value
            }, function () {
                _this.template.commentInput.value = '';
                closeComment();
            });
        };
        this.template.commentInput.addEventListener('click', function () {
            closeCommentSetting();
        });
        this.template.commentInput.addEventListener('keydown', function (e) {
            var event = e || window.event;
            if (event.keyCode === 13) {
                sendComment();
            }
        });
        this.template.commentSendButton.addEventListener('click', sendComment);
        this.fullScreen = new _fullscreen2.default(this);
        this.template.browserFullButton.addEventListener('click', function () {
            _this.fullScreen.toggle('browser');
        });
        this.template.webFullButton.addEventListener('click', function () {
            _this.fullScreen.toggle('web');
        });
        var handleKeyDown = function handleKeyDown(e) {
            if (_this.focus) {
                var tag = document.activeElement.tagName.toUpperCase();
                var editable = document.activeElement.getAttribute('contenteditable');
                if (tag !== 'INPUT' && tag !== 'TEXTAREA' && editable !== '' && editable !== 'true') {
                    var event = e || window.event;
                    var percentage = void 0;
                    switch (event.keyCode) {
                    case 32:
                        event.preventDefault();
                        _this.toggle();
                        break;
                    case 37:
                        event.preventDefault();
                        _this.seek(_this.video.currentTime - 5);
                        hideController();
                        break;
                    case 39:
                        event.preventDefault();
                        _this.seek(_this.video.currentTime + 5);
                        hideController();
                        break;
                    case 38:
                        event.preventDefault();
                        percentage = _this.volume() + 0.1;
                        _this.volume(percentage);
                        break;
                    case 40:
                        event.preventDefault();
                        percentage = _this.volume() - 0.1;
                        _this.volume(percentage);
                        break;
                    }
                }
            }
        };
        if (this.options.hotkey) {
            document.addEventListener('keydown', handleKeyDown);
        }
        document.addEventListener('keydown', function (e) {
            var event = e || window.event;
            switch (event.keyCode) {
            case 27:
                if (_this.fullScreen.isFullScreen('web')) {
                    _this.fullScreen.cancel('web');
                }
                break;
            }
        });
        this.container.addEventListener('contextmenu', function (e) {
            var event = e || window.event;
            event.preventDefault();
            _this.template.menu.classList.add('dplayer-menu-show');
            var clientRect = _this.container.getBoundingClientRect();
            var menuLeft = event.clientX - clientRect.left;
            var menuTop = event.clientY - clientRect.top;
            if (menuLeft + _this.template.menu.offsetWidth >= clientRect.width) {
                _this.template.menu.style.right = clientRect.width - menuLeft + 'px';
                _this.template.menu.style.left = 'initial';
            } else {
                _this.template.menu.style.left = event.clientX - _this.container.getBoundingClientRect().left + 'px';
                _this.template.menu.style.right = 'initial';
            }
            if (menuTop + _this.template.menu.offsetHeight >= clientRect.height) {
                _this.template.menu.style.bottom = clientRect.height - menuTop + 'px';
                _this.template.menu.style.top = 'initial';
            } else {
                _this.template.menu.style.top = event.clientY - _this.container.getBoundingClientRect().top + 'px';
                _this.template.menu.style.bottom = 'initial';
            }
            _this.template.mask.classList.add('dplayer-mask-show');
            _this.events.trigger('contextmenu_show');
            _this.template.mask.addEventListener('click', function () {
                _this.template.mask.classList.remove('dplayer-mask-show');
                _this.template.menu.classList.remove('dplayer-menu-show');
                _this.events.trigger('contextmenu_hide');
            });
        });
        if (this.options.video.quality) {
            this.template.qualityList.addEventListener('click', function (e) {
                if (e.target.classList.contains('dplayer-quality-item')) {
                    _this.switchQuality(e.target.dataset.index);
                }
            });
        }
        if (this.options.screenshot) {
            this.template.camareButton.addEventListener('click', function () {
                var canvas = document.createElement('canvas');
                canvas.width = _this.video.videoWidth;
                canvas.height = _this.video.videoHeight;
                canvas.getContext('2d').drawImage(_this.video, 0, 0, canvas.width, canvas.height);
                var dataURL = canvas.toDataURL();
                _this.template.camareButton.href = dataURL;
                _this.template.camareButton.download = 'DPlayer.png';
                _this.events.trigger('screenshot', dataURL);
            });
        }
        if (this.options.subtitle) {
            this.events.on('subtitle_show', function () {
                _this.template.subtitleButton.dataset.balloon = _this.tran('Hide subtitle');
                _this.template.subtitleButtonInner.style.opacity = '';
                _this.user.set('subtitle', 1);
            });
            this.events.on('subtitle_hide', function () {
                _this.template.subtitleButton.dataset.balloon = _this.tran('Show subtitle');
                _this.template.subtitleButtonInner.style.opacity = '0.4';
                _this.user.set('subtitle', 0);
            });
            this.template.subtitleButton.addEventListener('click', function () {
                _this.subtitle.toggle();
            });
        }
        this.initVideo(this.video, this.quality && this.quality.type || this.options.video.type);
        index++;
        instances.push(this);
    }
    _createClass(DPlayer, [
        {
            key: 'seek',
            value: function seek(time) {
                time = Math.max(time, 0);
                if (this.video.duration) {
                    time = Math.min(time, this.video.duration);
                }
                if (this.video.currentTime < time) {
                    this.notice(this.tran('FF') + ' ' + (time - this.video.currentTime).toFixed(0) + ' ' + this.tran('s'));
                } else if (this.video.currentTime > time) {
                    this.notice(this.tran('REW') + ' ' + (this.video.currentTime - time).toFixed(0) + ' ' + this.tran('s'));
                }
                this.video.currentTime = time;
                if (this.danmaku) {
                    this.danmaku.seek();
                }
                this.updateBar('played', time / this.video.duration, 'width');
            }
        },
        {
            key: 'play',
            value: function play() {
                this.paused = false;
                if (this.video.paused) {
                    this.template.bezel.innerHTML = this.icons.get('play');
                    this.template.bezel.classList.add('dplayer-bezel-transition');
                }
                this.template.playButton.innerHTML = this.icons.get('pause');
                this.video.play();
                this.setTime();
                this.container.classList.add('dplayer-playing');
                if (this.danmaku) {
                    this.danmaku.play();
                }
                if (this.options.mutex) {
                    for (var i = 0; i < instances.length; i++) {
                        if (this !== instances[i]) {
                            instances[i].pause();
                        }
                    }
                }
            }
        },
        {
            key: 'pause',
            value: function pause() {
                this.paused = true;
                this.container.classList.remove('dplayer-loading');
                if (!this.video.paused) {
                    this.template.bezel.innerHTML = this.icons.get('pause');
                    this.template.bezel.classList.add('dplayer-bezel-transition');
                }
                this.ended = false;
                this.template.playButton.innerHTML = this.icons.get('play');
                this.video.pause();
                this.clearTime();
                this.container.classList.remove('dplayer-playing');
                if (this.danmaku) {
                    this.danmaku.pause();
                }
            }
        },
        {
            key: 'volume',
            value: function volume(percentage, nostorage, nonotice) {
                percentage = parseFloat(percentage);
                if (!isNaN(percentage)) {
                    percentage = percentage > 0 ? percentage : 0;
                    percentage = percentage < 1 ? percentage : 1;
                    this.updateBar('volume', percentage, 'width');
                    var formatPercentage = (percentage * 100).toFixed(0) + '%';
                    this.template.volumeBarWrapWrap.dataset.balloon = formatPercentage;
                    if (!nostorage) {
                        this.user.set('volume', percentage);
                    }
                    if (!nonotice) {
                        this.notice(this.tran('Volume') + ' ' + (percentage * 100).toFixed(0) + '%');
                    }
                    this.video.volume = percentage;
                    if (this.video.muted) {
                        this.video.muted = false;
                    }
                    this.switchVolumeIcon();
                }
                return this.video.volume;
            }
        },
        {
            key: 'toggle',
            value: function toggle() {
                if (this.video.paused) {
                    this.play();
                } else {
                    this.pause();
                }
            }
        },
        {
            key: 'on',
            value: function on(name, callback) {
                this.events.on(name, callback);
            }
        },
        {
            key: 'switchVideo',
            value: function switchVideo(video, danmakuAPI) {
                this.pause();
                this.video.poster = video.pic ? video.pic : '';
                this.video.src = video.url;
                this.initMSE(this.video, video.type || 'auto');
                if (danmakuAPI) {
                    this.template.danmakuLoading.style.display = 'block';
                    this.updateBar('played', 0, 'width');
                    this.updateBar('loaded', 0, 'width');
                    this.template.ptime.innerHTML = '00:00';
                    this.template.danmaku.innerHTML = '';
                    if (this.danmaku) {
                        this.danmaku.reload({
                            id: danmakuAPI.id,
                            address: danmakuAPI.api,
                            token: danmakuAPI.token,
                            maximum: danmakuAPI.maximum,
                            addition: danmakuAPI.addition,
                            user: danmakuAPI.user
                        });
                    }
                }
            }
        },
        {
            key: 'initMSE',
            value: function initMSE(video, type) {
                this.type = type;
                if (this.type === 'auto') {
                    if (/m3u8(#|\?|$)/i.exec(video.src)) {
                        this.type = 'hls';
                    } else if (/.flv(#|\?|$)/i.exec(video.src)) {
                        this.type = 'flv';
                    } else if (/.mpd(#|\?|$)/i.exec(video.src)) {
                        this.type = 'dash';
                    } else {
                        this.type = 'normal';
                    }
                }
                if (this.type === 'hls' && Hls && Hls.isSupported()) {
                    var hls = new Hls();
                    hls.loadSource(video.src);
                    hls.attachMedia(video);
                }
                if (this.type === 'flv' && flvjs && flvjs.isSupported()) {
                    var flvPlayer = flvjs.createPlayer({
                        type: 'flv',
                        url: video.src
                    });
                    flvPlayer.attachMediaElement(video);
                    flvPlayer.load();
                }
                if (this.type === 'dash' && dashjs) {
                    dashjs.MediaPlayer().create().initialize(video, video.src, false);
                }
            }
        },
        {
            key: 'initVideo',
            value: function initVideo(video, type) {
                var _this2 = this;
                this.initMSE(video, type);
                this.on('durationchange', function () {
                    if (video.duration !== 1) {
                        _this2.template.dtime.innerHTML = _utils2.default.secondToTime(video.duration);
                    }
                });
                this.on('progress', function () {
                    var percentage = video.buffered.length ? video.buffered.end(video.buffered.length - 1) / video.duration : 0;
                    _this2.updateBar('loaded', percentage, 'width');
                });
                this.on('error', function () {
                    _this2.tran && _this2.notice && _this2.notice(_this2.tran('This video fails to load'), -1);
                });
                this.ended = false;
                this.on('ended', function () {
                    _this2.updateBar('played', 1, 'width');
                    if (!_this2.loop) {
                        _this2.ended = true;
                        _this2.pause();
                    } else {
                        _this2.seek(0);
                        video.play();
                    }
                    if (_this2.danmaku) {
                        _this2.danmaku.danIndex = 0;
                    }
                });
                this.on('play', function () {
                    if (_this2.paused) {
                        _this2.play();
                    }
                });
                this.on('pause', function () {
                    if (!_this2.paused) {
                        _this2.pause();
                    }
                });
                var _loop2 = function _loop2(i) {
                    video.addEventListener(_this2.events.videoEvents[i], function () {
                        _this2.events.trigger(_this2.events.videoEvents[i]);
                    });
                };
                for (var i = 0; i < this.events.videoEvents.length; i++) {
                    _loop2(i);
                }
                this.volume(this.user.get('volume'), true, true);
                if (this.options.subtitle) {
                    this.subtitle = new _subtitle2.default(this.template.subtitle, this.video, this.options.subtitle, this.events);
                    if (!this.user.get('subtitle')) {
                        this.subtitle.hide();
                    }
                }
            }
        },
        {
            key: 'switchQuality',
            value: function switchQuality(index) {
                var _this3 = this;
                if (this.qualityIndex === index || this.switchingQuality) {
                    return;
                } else {
                    this.qualityIndex = index;
                }
                this.switchingQuality = true;
                this.quality = this.options.video.quality[index];
                this.template.qualityButton.innerHTML = this.quality.name;
                var paused = this.video.paused;
                this.video.pause();
                var videoHTML = this.template.tplVideo(false, null, this.options.screenshot, 'auto', this.quality.url, this.options.subtitle);
                var videoEle = new DOMParser().parseFromString(videoHTML, 'text/html').body.firstChild;
                this.template.videoWrap.insertBefore(videoEle, this.template.videoWrap.getElementsByTagName('div')[0]);
                this.prevVideo = this.video;
                this.video = videoEle;
                this.initVideo(this.video, this.quality.type || this.options.video.type);
                this.seek(this.prevVideo.currentTime);
                this.notice(this.tran('Switching to') + ' ' + this.quality.name + ' ' + this.tran('quality'), -1);
                this.events.trigger('quality_start', this.quality);
                this.on('canplay', function () {
                    if (_this3.prevVideo) {
                        if (_this3.video.currentTime !== _this3.prevVideo.currentTime) {
                            _this3.seek(_this3.prevVideo.currentTime);
                            return;
                        }
                        _this3.template.videoWrap.removeChild(_this3.prevVideo);
                        _this3.video.classList.add('dplayer-video-current');
                        if (!paused) {
                            _this3.video.play();
                        }
                        _this3.prevVideo = null;
                        _this3.notice(_this3.tran('Switched to') + ' ' + _this3.quality.name + ' ' + _this3.tran('quality'));
                        _this3.switchingQuality = false;
                        _this3.events.trigger('quality_end');
                    }
                });
            }
        },
        {
            key: 'mouseHandler',
            value: function mouseHandler(pbar, timeTips) {
                var _this4 = this;
                var cumulativeOffset = function cumulativeOffset(element) {
                    var top = 0, left = 0;
                    do {
                        top += element.offsetTop || 0;
                        left += element.offsetLeft || 0;
                        element = element.offsetParent;
                    } while (element);
                    return {
                        top: top,
                        left: left
                    };
                };
                return function (e) {
                    if (!_this4.video.duration) {
                        return;
                    }
                    var clientX = e.clientX;
                    var px = cumulativeOffset(pbar).left;
                    var tx = clientX - px;
                    if (tx < 0 || tx > pbar.offsetWidth) {
                        return;
                    }
                    var time = _this4.video.duration * (tx / pbar.offsetWidth);
                    timeTips.style.left = tx - 20 + 'px';
                    switch (e.type) {
                    case 'mouseenter':
                        _this4.thumbnails && _this4.thumbnails.show();
                        break;
                    case 'mousemove':
                        _this4.thumbnails && _this4.thumbnails.move(tx);
                        timeTips.innerText = _utils2.default.secondToTime(time);
                        _this4.timeTipsDisplay(true, timeTips);
                        break;
                    case 'mouseleave':
                        _this4.thumbnails && _this4.thumbnails.hide();
                        _this4.timeTipsDisplay(false, timeTips);
                        break;
                    }
                };
            }
        },
        {
            key: 'timeTipsDisplay',
            value: function timeTipsDisplay(show, timeTips) {
                if (show) {
                    if (this.isTimeTipsShow) {
                        return;
                    }
                    timeTips.classList.remove('hidden');
                    this.isTimeTipsShow = true;
                } else {
                    if (!this.isTimeTipsShow) {
                        return;
                    }
                    timeTips.classList.add('hidden');
                    this.isTimeTipsShow = false;
                }
            }
        },
        {
            key: 'initThumbnails',
            value: function initThumbnails() {
                var _this5 = this;
                this.thumbnails = new _thumbnails2.default(this.template.barPreview, this.template.barWrap.offsetWidth, this.options.video.thumbnails, this.events);
                this.on('loadedmetadata', function () {
                    _this5.thumbnails.resize(160, 90);
                });
            }
        },
        {
            key: 'notice',
            value: function notice(text) {
                var _this6 = this;
                var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2000;
                var opacity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.8;
                this.template.notice.innerHTML = text;
                this.template.notice.style.opacity = opacity;
                if (this.noticeTime) {
                    clearTimeout(this.noticeTime);
                }
                this.events.trigger('notice_show', text);
                this.noticeTime = setTimeout(function () {
                    _this6.template.notice.style.opacity = 0;
                    _this6.events.trigger('notice_hide');
                }, time);
            }
        },
        {
            key: 'resize',
            value: function resize() {
                if (this.danmaku) {
                    this.danmaku.resize();
                }
                this.events.trigger('resize');
            }
        },
        {
            key: 'destroy',
            value: function destroy() {
                instances.splice(instances.indexOf(this), 1);
                this.pause();
                clearTimeout(this.hideTime);
                this.video.src = '';
                this.container.innerHTML = '';
                this.events.trigger('destroy');
                for (var key in this) {
                    if (this.hasOwnProperty(key) && key !== 'paused') {
                        delete this[key];
                    }
                }
            }
        }
    ]);
    return DPlayer;
}();
module.exports = DPlayer;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _typeof = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? function (obj) {
    return typeof obj;
} : function (obj) {
    return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
};
var defaultApiBackend = __webpack_require__(5);
module.exports = function (options) {
    var isMobile = /mobile/i.test(window.navigator.userAgent);
    if (isMobile) {
        options.autoplay = false;
    }
    var defaultOption = {
        container: options.element || document.getElementsByClassName('dplayer')[0],
        live: false,
        autoplay: false,
        theme: '#b7daff',
        loop: false,
        lang: (navigator.language || navigator.browserLanguage).toLowerCase(),
        screenshot: false,
        hotkey: true,
        preload: 'auto',
        volume: 0.7,
        apiBackend: defaultApiBackend,
        video: {},
        icons: {
            play: [
                '0 0 16 32',
                'M15.552 15.168q0.448 0.32 0.448 0.832 0 0.448-0.448 0.768l-13.696 8.512q-0.768 0.512-1.312 0.192t-0.544-1.28v-16.448q0-0.96 0.544-1.28t1.312 0.192z'
            ],
            pause: [
                '0 0 17 32',
                'M14.080 4.8q2.88 0 2.88 2.048v18.24q0 2.112-2.88 2.112t-2.88-2.112v-18.24q0-2.048 2.88-2.048zM2.88 4.8q2.88 0 2.88 2.048v18.24q0 2.112-2.88 2.112t-2.88-2.112v-18.24q0-2.048 2.88-2.048z'
            ],
            'volume-up': [
                '0 0 21 32',
                'M13.728 6.272v19.456q0 0.448-0.352 0.8t-0.8 0.32-0.8-0.32l-5.952-5.952h-4.672q-0.48 0-0.8-0.352t-0.352-0.8v-6.848q0-0.48 0.352-0.8t0.8-0.352h4.672l5.952-5.952q0.32-0.32 0.8-0.32t0.8 0.32 0.352 0.8zM20.576 16q0 1.344-0.768 2.528t-2.016 1.664q-0.16 0.096-0.448 0.096-0.448 0-0.8-0.32t-0.32-0.832q0-0.384 0.192-0.64t0.544-0.448 0.608-0.384 0.512-0.64 0.192-1.024-0.192-1.024-0.512-0.64-0.608-0.384-0.544-0.448-0.192-0.64q0-0.48 0.32-0.832t0.8-0.32q0.288 0 0.448 0.096 1.248 0.48 2.016 1.664t0.768 2.528zM25.152 16q0 2.72-1.536 5.056t-4 3.36q-0.256 0.096-0.448 0.096-0.48 0-0.832-0.352t-0.32-0.8q0-0.704 0.672-1.056 1.024-0.512 1.376-0.8 1.312-0.96 2.048-2.4t0.736-3.104-0.736-3.104-2.048-2.4q-0.352-0.288-1.376-0.8-0.672-0.352-0.672-1.056 0-0.448 0.32-0.8t0.8-0.352q0.224 0 0.48 0.096 2.496 1.056 4 3.36t1.536 5.056z'
            ],
            'volume-down': [
                '0 0 21 32',
                'M13.728 6.272v19.456q0 0.448-0.352 0.8t-0.8 0.32-0.8-0.32l-5.952-5.952h-4.672q-0.48 0-0.8-0.352t-0.352-0.8v-6.848q0-0.48 0.352-0.8t0.8-0.352h4.672l5.952-5.952q0.32-0.32 0.8-0.32t0.8 0.32 0.352 0.8zM20.576 16q0 1.344-0.768 2.528t-2.016 1.664q-0.16 0.096-0.448 0.096-0.448 0-0.8-0.32t-0.32-0.832q0-0.384 0.192-0.64t0.544-0.448 0.608-0.384 0.512-0.64 0.192-1.024-0.192-1.024-0.512-0.64-0.608-0.384-0.544-0.448-0.192-0.64q0-0.48 0.32-0.832t0.8-0.32q0.288 0 0.448 0.096 1.248 0.48 2.016 1.664t0.768 2.528z'
            ],
            'volume-off': [
                '0 0 21 32',
                'M13.728 6.272v19.456q0 0.448-0.352 0.8t-0.8 0.32-0.8-0.32l-5.952-5.952h-4.672q-0.48 0-0.8-0.352t-0.352-0.8v-6.848q0-0.48 0.352-0.8t0.8-0.352h4.672l5.952-5.952q0.32-0.32 0.8-0.32t0.8 0.32 0.352 0.8z'
            ],
            loop: [
                '0 0 32 32',
                'M1.882 16.941c0 4.152 3.221 7.529 7.177 7.529v1.882c-4.996 0-9.060-4.222-9.060-9.412s4.064-9.412 9.060-9.412h7.96l-3.098-3.098 1.331-1.331 5.372 5.37-5.37 5.372-1.333-1.333 3.1-3.098h-7.962c-3.957 0-7.177 3.377-7.177 7.529zM22.94 7.529v1.882c3.957 0 7.177 3.377 7.177 7.529s-3.221 7.529-7.177 7.529h-7.962l3.098-3.098-1.331-1.331-5.37 5.37 5.372 5.372 1.331-1.331-3.1-3.1h7.96c4.998 0 9.062-4.222 9.062-9.412s-4.064-9.412-9.060-9.412z'
            ],
            full: [
                '0 0 32 33',
                'M6.667 28h-5.333c-0.8 0-1.333-0.533-1.333-1.333v-5.333c0-0.8 0.533-1.333 1.333-1.333s1.333 0.533 1.333 1.333v4h4c0.8 0 1.333 0.533 1.333 1.333s-0.533 1.333-1.333 1.333zM30.667 28h-5.333c-0.8 0-1.333-0.533-1.333-1.333s0.533-1.333 1.333-1.333h4v-4c0-0.8 0.533-1.333 1.333-1.333s1.333 0.533 1.333 1.333v5.333c0 0.8-0.533 1.333-1.333 1.333zM30.667 12c-0.8 0-1.333-0.533-1.333-1.333v-4h-4c-0.8 0-1.333-0.533-1.333-1.333s0.533-1.333 1.333-1.333h5.333c0.8 0 1.333 0.533 1.333 1.333v5.333c0 0.8-0.533 1.333-1.333 1.333zM1.333 12c-0.8 0-1.333-0.533-1.333-1.333v-5.333c0-0.8 0.533-1.333 1.333-1.333h5.333c0.8 0 1.333 0.533 1.333 1.333s-0.533 1.333-1.333 1.333h-4v4c0 0.8-0.533 1.333-1.333 1.333z'
            ],
            'full-in': [
                '0 0 32 33',
                'M24.965 24.38h-18.132c-1.366 0-2.478-1.113-2.478-2.478v-11.806c0-1.364 1.111-2.478 2.478-2.478h18.132c1.366 0 2.478 1.113 2.478 2.478v11.806c0 1.364-1.11 2.478-2.478 2.478zM6.833 10.097v11.806h18.134l-0.002-11.806h-18.132zM2.478 28.928h5.952c0.684 0 1.238-0.554 1.238-1.239 0-0.684-0.554-1.238-1.238-1.238h-5.952v-5.802c0-0.684-0.554-1.239-1.238-1.239s-1.239 0.556-1.239 1.239v5.802c0 1.365 1.111 2.478 2.478 2.478zM30.761 19.412c-0.684 0-1.238 0.554-1.238 1.238v5.801h-5.951c-0.686 0-1.239 0.554-1.239 1.238 0 0.686 0.554 1.239 1.239 1.239h5.951c1.366 0 2.478-1.111 2.478-2.478v-5.801c0-0.683-0.554-1.238-1.239-1.238zM0 5.55v5.802c0 0.683 0.554 1.238 1.238 1.238s1.238-0.555 1.238-1.238v-5.802h5.952c0.684 0 1.238-0.554 1.238-1.238s-0.554-1.238-1.238-1.238h-5.951c-1.366-0.001-2.478 1.111-2.478 2.476zM32 11.35v-5.801c0-1.365-1.11-2.478-2.478-2.478h-5.951c-0.686 0-1.239 0.554-1.239 1.238s0.554 1.238 1.239 1.238h5.951v5.801c0 0.683 0.554 1.237 1.238 1.237 0.686 0.002 1.239-0.553 1.239-1.236z'
            ],
            setting: [
                '0 0 32 28',
                'M28.633 17.104c0.035 0.21 0.026 0.463-0.026 0.76s-0.14 0.598-0.262 0.904c-0.122 0.306-0.271 0.581-0.445 0.825s-0.367 0.419-0.576 0.524c-0.209 0.105-0.393 0.157-0.55 0.157s-0.332-0.035-0.524-0.105c-0.175-0.052-0.393-0.1-0.655-0.144s-0.528-0.052-0.799-0.026c-0.271 0.026-0.541 0.083-0.812 0.17s-0.502 0.236-0.694 0.445c-0.419 0.437-0.664 0.934-0.734 1.493s0.009 1.092 0.236 1.598c0.175 0.349 0.148 0.699-0.079 1.048-0.105 0.14-0.271 0.284-0.498 0.432s-0.476 0.284-0.747 0.406-0.555 0.218-0.851 0.288c-0.297 0.070-0.559 0.105-0.786 0.105-0.157 0-0.306-0.061-0.445-0.183s-0.236-0.253-0.288-0.393h-0.026c-0.192-0.541-0.52-1.009-0.982-1.402s-1-0.589-1.611-0.589c-0.594 0-1.131 0.197-1.611 0.589s-0.816 0.851-1.009 1.375c-0.087 0.21-0.218 0.362-0.393 0.458s-0.367 0.144-0.576 0.144c-0.244 0-0.52-0.044-0.825-0.131s-0.611-0.197-0.917-0.327c-0.306-0.131-0.581-0.284-0.825-0.458s-0.428-0.349-0.55-0.524c-0.087-0.122-0.135-0.266-0.144-0.432s0.057-0.397 0.197-0.694c0.192-0.402 0.266-0.86 0.223-1.375s-0.266-0.991-0.668-1.428c-0.244-0.262-0.541-0.432-0.891-0.511s-0.681-0.109-0.995-0.092c-0.367 0.017-0.742 0.087-1.127 0.21-0.244 0.070-0.489 0.052-0.734-0.052-0.192-0.070-0.371-0.231-0.537-0.485s-0.314-0.533-0.445-0.838c-0.131-0.306-0.231-0.62-0.301-0.943s-0.087-0.59-0.052-0.799c0.052-0.384 0.227-0.629 0.524-0.734 0.524-0.21 0.995-0.555 1.415-1.035s0.629-1.017 0.629-1.611c0-0.611-0.21-1.144-0.629-1.598s-0.891-0.786-1.415-0.996c-0.157-0.052-0.288-0.179-0.393-0.38s-0.157-0.406-0.157-0.616c0-0.227 0.035-0.48 0.105-0.76s0.162-0.55 0.275-0.812 0.244-0.502 0.393-0.72c0.148-0.218 0.31-0.38 0.485-0.485 0.14-0.087 0.275-0.122 0.406-0.105s0.275 0.052 0.432 0.105c0.524 0.21 1.070 0.275 1.637 0.197s1.070-0.327 1.506-0.747c0.21-0.209 0.362-0.467 0.458-0.773s0.157-0.607 0.183-0.904c0.026-0.297 0.026-0.568 0-0.812s-0.048-0.419-0.065-0.524c-0.035-0.105-0.066-0.227-0.092-0.367s-0.013-0.262 0.039-0.367c0.105-0.244 0.293-0.458 0.563-0.642s0.563-0.336 0.878-0.458c0.314-0.122 0.62-0.214 0.917-0.275s0.533-0.092 0.707-0.092c0.227 0 0.406 0.074 0.537 0.223s0.223 0.301 0.275 0.458c0.192 0.471 0.507 0.886 0.943 1.244s0.952 0.537 1.546 0.537c0.611 0 1.153-0.17 1.624-0.511s0.803-0.773 0.996-1.297c0.070-0.14 0.179-0.284 0.327-0.432s0.301-0.223 0.458-0.223c0.244 0 0.511 0.035 0.799 0.105s0.572 0.166 0.851 0.288c0.279 0.122 0.537 0.279 0.773 0.472s0.423 0.402 0.563 0.629c0.087 0.14 0.113 0.293 0.079 0.458s-0.070 0.284-0.105 0.354c-0.227 0.506-0.297 1.039-0.21 1.598s0.341 1.048 0.76 1.467c0.419 0.419 0.934 0.651 1.546 0.694s1.179-0.057 1.703-0.301c0.14-0.087 0.31-0.122 0.511-0.105s0.371 0.096 0.511 0.236c0.262 0.244 0.493 0.616 0.694 1.113s0.336 1 0.406 1.506c0.035 0.297-0.013 0.528-0.144 0.694s-0.266 0.275-0.406 0.327c-0.542 0.192-1.004 0.528-1.388 1.009s-0.576 1.026-0.576 1.637c0 0.594 0.162 1.113 0.485 1.559s0.747 0.764 1.27 0.956c0.122 0.070 0.227 0.14 0.314 0.21 0.192 0.157 0.323 0.358 0.393 0.602v0zM16.451 19.462c0.786 0 1.528-0.149 2.227-0.445s1.305-0.707 1.821-1.231c0.515-0.524 0.921-1.131 1.218-1.821s0.445-1.428 0.445-2.214c0-0.786-0.148-1.524-0.445-2.214s-0.703-1.292-1.218-1.808c-0.515-0.515-1.122-0.921-1.821-1.218s-1.441-0.445-2.227-0.445c-0.786 0-1.524 0.148-2.214 0.445s-1.292 0.703-1.808 1.218c-0.515 0.515-0.921 1.118-1.218 1.808s-0.445 1.428-0.445 2.214c0 0.786 0.149 1.524 0.445 2.214s0.703 1.297 1.218 1.821c0.515 0.524 1.118 0.934 1.808 1.231s1.428 0.445 2.214 0.445v0z'
            ],
            right: [
                '0 0 32 32',
                'M22 16l-10.105-10.6-1.895 1.987 8.211 8.613-8.211 8.612 1.895 1.988 8.211-8.613z'
            ],
            comment: [
                '0 0 32 32',
                'M27.128 0.38h-22.553c-2.336 0-4.229 1.825-4.229 4.076v16.273c0 2.251 1.893 4.076 4.229 4.076h4.229v-2.685h8.403l-8.784 8.072 1.566 1.44 7.429-6.827h9.71c2.335 0 4.229-1.825 4.229-4.076v-16.273c0-2.252-1.894-4.076-4.229-4.076zM28.538 19.403c0 1.5-1.262 2.717-2.819 2.717h-8.36l-0.076-0.070-0.076 0.070h-11.223c-1.557 0-2.819-1.217-2.819-2.717v-13.589c0-1.501 1.262-2.718 2.819-2.718h19.734c1.557 0 2.819-0.141 2.819 1.359v14.947zM9.206 10.557c-1.222 0-2.215 0.911-2.215 2.036s0.992 2.035 2.215 2.035c1.224 0 2.216-0.911 2.216-2.035s-0.992-2.036-2.216-2.036zM22.496 10.557c-1.224 0-2.215 0.911-2.215 2.036s0.991 2.035 2.215 2.035c1.224 0 2.215-0.911 2.215-2.035s-0.991-2.036-2.215-2.036zM15.852 10.557c-1.224 0-2.215 0.911-2.215 2.036s0.991 2.035 2.215 2.035c1.222 0 2.215-0.911 2.215-2.035s-0.992-2.036-2.215-2.036z'
            ],
            'comment-off': [
                '0 0 32 32',
                'M27.090 0.131h-22.731c-2.354 0-4.262 1.839-4.262 4.109v16.401c0 2.269 1.908 4.109 4.262 4.109h4.262v-2.706h8.469l-8.853 8.135 1.579 1.451 7.487-6.88h9.787c2.353 0 4.262-1.84 4.262-4.109v-16.401c0-2.27-1.909-4.109-4.262-4.109v0zM28.511 19.304c0 1.512-1.272 2.738-2.841 2.738h-8.425l-0.076-0.070-0.076 0.070h-11.311c-1.569 0-2.841-1.226-2.841-2.738v-13.696c0-1.513 1.272-2.739 2.841-2.739h19.889c1.569 0 2.841-0.142 2.841 1.37v15.064z'
            ],
            send: [
                '0 0 32 32',
                'M13.725 30l3.9-5.325-3.9-1.125v6.45zM0 17.5l11.050 3.35 13.6-11.55-10.55 12.425 11.8 3.65 6.1-23.375-32 15.5z'
            ],
            pallette: [
                '0 0 32 32',
                'M19.357 2.88c1.749 0 3.366 0.316 4.851 0.946 1.485 0.632 2.768 1.474 3.845 2.533s1.922 2.279 2.532 3.661c0.611 1.383 0.915 2.829 0.915 4.334 0 1.425-0.304 2.847-0.915 4.271-0.611 1.425-1.587 2.767-2.928 4.028-0.855 0.813-1.811 1.607-2.869 2.38s-2.136 1.465-3.233 2.075c-1.099 0.61-2.198 1.098-3.296 1.465-1.098 0.366-2.115 0.549-3.051 0.549-1.343 0-2.441-0.438-3.296-1.311-0.854-0.876-1.281-2.41-1.281-4.608 0-0.366 0.020-0.773 0.060-1.221s0.062-0.895 0.062-1.343c0-0.773-0.183-1.353-0.55-1.738-0.366-0.387-0.793-0.58-1.281-0.58-0.652 0-1.21 0.295-1.678 0.886s-0.926 1.23-1.373 1.921c-0.447 0.693-0.905 1.334-1.372 1.923s-1.028 0.886-1.679 0.886c-0.529 0-1.048-0.427-1.556-1.282s-0.763-2.259-0.763-4.212c0-2.197 0.529-4.241 1.587-6.133s2.462-3.529 4.21-4.912c1.75-1.383 3.762-2.471 6.041-3.264 2.277-0.796 4.617-1.212 7.018-1.253zM7.334 15.817c0.569 0 1.047-0.204 1.434-0.611s0.579-0.875 0.579-1.404c0-0.569-0.193-1.047-0.579-1.434s-0.864-0.579-1.434-0.579c-0.529 0-0.987 0.193-1.373 0.579s-0.58 0.864-0.58 1.434c0 0.53 0.194 0.998 0.58 1.404 0.388 0.407 0.845 0.611 1.373 0.611zM12.216 11.79c0.691 0 1.292-0.254 1.8-0.763s0.762-1.107 0.762-1.8c0-0.732-0.255-1.343-0.762-1.831-0.509-0.489-1.109-0.732-1.8-0.732-0.732 0-1.342 0.244-1.831 0.732-0.488 0.488-0.732 1.098-0.732 1.831 0 0.693 0.244 1.292 0.732 1.8s1.099 0.763 1.831 0.763zM16.366 25.947c0.692 0 1.282-0.214 1.77-0.64s0.732-0.987 0.732-1.678-0.244-1.261-0.732-1.709c-0.489-0.448-1.078-0.671-1.77-0.671-0.65 0-1.21 0.223-1.678 0.671s-0.702 1.018-0.702 1.709c0 0.692 0.234 1.25 0.702 1.678s1.027 0.64 1.678 0.64zM19.113 9.592c0.651 0 1.129-0.203 1.433-0.611 0.305-0.406 0.459-0.874 0.459-1.404 0-0.488-0.154-0.947-0.459-1.373-0.304-0.427-0.782-0.641-1.433-0.641-0.529 0-1.008 0.193-1.434 0.58s-0.64 0.865-0.64 1.434c0 0.571 0.213 1.049 0.64 1.434 0.427 0.389 0.905 0.581 1.434 0.581zM24.848 12.826c0.57 0 1.067-0.213 1.495-0.64 0.427-0.427 0.64-0.947 0.64-1.556 0-0.57-0.214-1.068-0.64-1.495-0.428-0.427-0.927-0.64-1.495-0.64-0.611 0-1.129 0.213-1.555 0.64-0.428 0.427-0.642 0.926-0.642 1.495 0 0.611 0.213 1.129 0.642 1.556s0.947 0.64 1.555 0.64z'
            ],
            camera: [
                '0 0 32 32',
                'M16 23c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6zM16 13c-2.206 0-4 1.794-4 4s1.794 4 4 4c2.206 0 4-1.794 4-4s-1.794-4-4-4zM27 28h-22c-1.654 0-3-1.346-3-3v-16c0-1.654 1.346-3 3-3h3c0.552 0 1 0.448 1 1s-0.448 1-1 1h-3c-0.551 0-1 0.449-1 1v16c0 0.552 0.449 1 1 1h22c0.552 0 1-0.448 1-1v-16c0-0.551-0.448-1-1-1h-11c-0.552 0-1-0.448-1-1s0.448-1 1-1h11c1.654 0 3 1.346 3 3v16c0 1.654-1.346 3-3 3zM24 10.5c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5zM15 4c0 0.552-0.448 1-1 1h-4c-0.552 0-1-0.448-1-1v0c0-0.552 0.448-1 1-1h4c0.552 0 1 0.448 1 1v0z'
            ],
            subtitle: [
                '0 0 32 32',
                'M26.667 5.333h-21.333c-0 0-0.001 0-0.001 0-1.472 0-2.666 1.194-2.666 2.666 0 0 0 0.001 0 0.001v-0 16c0 0 0 0.001 0 0.001 0 1.472 1.194 2.666 2.666 2.666 0 0 0.001 0 0.001 0h21.333c0 0 0.001 0 0.001 0 1.472 0 2.666-1.194 2.666-2.666 0-0 0-0.001 0-0.001v0-16c0-0 0-0.001 0-0.001 0-1.472-1.194-2.666-2.666-2.666-0 0-0.001 0-0.001 0h0zM5.333 16h5.333v2.667h-5.333v-2.667zM18.667 24h-13.333v-2.667h13.333v2.667zM26.667 24h-5.333v-2.667h5.333v2.667zM26.667 18.667h-13.333v-2.667h13.333v2.667z'
            ]
        },
        iconsColor: '#ffffff',
        contextmenu: [],
        mutex: true
    };
    for (var defaultKey in defaultOption) {
        if (defaultOption.hasOwnProperty(defaultKey) && !options.hasOwnProperty(defaultKey)) {
            options[defaultKey] = defaultOption[defaultKey];
        }
    }
    if (options.video) {
        !options.video.type && (options.video.type = 'auto');
    }
    if (_typeof(options.danmaku) === 'object' && options.danmaku) {
        !options.danmaku.user && (options.danmaku.user = 'DIYgod');
    }
    if (options.subtitle) {
        !options.subtitle.type && (options.subtitle.type = 'webvtt');
        !options.subtitle.fontSize && (options.subtitle.fontSize = '20px');
        !options.subtitle.bottom && (options.subtitle.bottom = '40px');
        !options.subtitle.color && (options.subtitle.color = '#fff');
    }
    if (options.video.quality) {
        options.video.url = [options.video.quality[options.video.defaultQuality].url];
    }
    if (options.lang) {
        options.lang = options.lang.toLowerCase();
    }
    if (options.icons) {
        options.icons = Object.assign({}, defaultOption.icons, options.icons);
    }
    options.contextmenu = options.contextmenu.concat([
        {
            text: 'About author',
            link: 'https://diygod.me'
        },
        {
            text: 'About DPlayer',
            link: 'https://github.com/MoePlayer/DPlayer'
        },
        {
            text: 'DPlayer feedback',
            link: 'https://github.com/DIYgod/DPlayer/issues'
        },
        {
            text: 'DPlayer ' + "1.17.2" + ' ' + "4c587e5",
            link: 'https://github.com/MoePlayer/DPlayer/releases'
        }
    ]);
    return options;
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var SendXMLHttpRequest = function SendXMLHttpRequest(url, data, success, error, fail) {
    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
            if (xhr.status >= 200 && xhr.status < 300 || xhr.status === 304) {
                var response = JSON.parse(xhr.responseText);
                if (response.code !== 1) {
                    return error(xhr, response);
                }
                return success(xhr, response);
            }
            fail(xhr);
        }
    };
    xhr.open(data !== null ? 'POST' : 'GET', url, true);
    xhr.send(data !== null ? JSON.stringify(data) : null);
};
module.exports = {
    send: function send(endpoint, danmakuData, callback) {
        SendXMLHttpRequest(endpoint, danmakuData, function (xhr, response) {
            console.log('Post danmaku: ', response);
            if (callback) {
                callback();
            }
        }, function (xhr, response) {
            alert(response.msg);
        }, function (xhr) {
            console.log('Request was unsuccessful: ' + xhr.status);
        });
    },
    read: function read(endpoint, callback) {
        SendXMLHttpRequest(endpoint, null, function (xhr, response) {
            callback(null, response.danmaku);
        }, function (xhr, response) {
            callback({
                status: xhr.status,
                response: response
            });
        }, function (xhr) {
            callback({
                status: xhr.status,
                response: null
            });
        });
    }
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (lang) {
    var _this = this;
    this.lang = lang;
    this.tran = function (text) {
        if (tranTxt[_this.lang] && tranTxt[_this.lang][text]) {
            return tranTxt[_this.lang][text];
        } else {
            return text;
        }
    };
};
var tranTxt = {
    'zh-cn': {
        'Danmaku is loading': '弹幕加载中',
        'Top': '顶部',
        'Bottom': '底部',
        'Rolling': '滚动',
        'Input danmaku, hit Enter': '输入弹幕\uFF0C回车发送',
        'About author': '关于作者',
        'DPlayer feedback': '播放器意见反馈',
        'About DPlayer': '关于 DPlayer 播放器',
        'Loop': '洗脑循环',
        'Speed': '速度',
        'Opacity for danmaku': '弹幕透明度',
        'Normal': '正常',
        'Please input danmaku content!': '要输入弹幕内容啊喂\uFF01',
        'Set danmaku color': '设置弹幕颜色',
        'Set danmaku type': '设置弹幕类型',
        'Show danmaku': '显示弹幕',
        'This video fails to load': '视频加载失败',
        'Switching to': '正在切换至',
        'Switched to': '已经切换至',
        'quality': '画质',
        'FF': '快进',
        'REW': '快退',
        'Unlimited danmaku': '海量弹幕',
        'Send danmaku': '发送弹幕',
        'Setting': '设置',
        'Full screen': '全屏',
        'Web full screen': '页面全屏',
        'Send': '发送',
        'Screenshot': '截图',
        's': '秒',
        'Show subtitle': '显示字幕',
        'Hide subtitle': '隐藏字幕',
        'Volume': '音量',
        'Live': '直播'
    },
    'zh-tw': {
        'Danmaku is loading': '彈幕加載中',
        'Top': '頂部',
        'Bottom': '底部',
        'Rolling': '滾動',
        'Input danmaku, hit Enter': '輸入彈幕\uFF0CEnter 發送',
        'About author': '關於作者',
        'DPlayer feedback': '播放器意見反饋',
        'About DPlayer': '關於 DPlayer 播放器',
        'Loop': '循環播放',
        'Speed': '速度',
        'Opacity for danmaku': '彈幕透明度',
        'Normal': '正常',
        'Please input danmaku content!': '請輸入彈幕内容啊\uFF01',
        'Set danmaku color': '設置彈幕顏色',
        'Set danmaku type': '設置彈幕類型',
        'Show danmaku': '顯示彈幕',
        'This video fails to load': '視頻加載失敗',
        'Switching to': '正在切換至',
        'Switched to': '已經切換至',
        'quality': '畫質',
        'FF': '快進',
        'REW': '快退',
        'Unlimited danmaku': '海量彈幕',
        'Send danmaku': '發送彈幕',
        'Setting': '設置',
        'Full screen': '全屏',
        'Web full screen': '頁面全屏',
        'Send': '發送',
        'Screenshot': '截圖',
        's': '秒',
        'Show subtitle': '顯示字幕',
        'Hide subtitle': '隱藏字幕',
        'Volume': '音量',
        'Live': '直播'
    }
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor)
                descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
var Template = function () {
    function Template(options) {
        _classCallCheck(this, Template);
        this.container = options.container;
        this.options = options.options;
        this.index = options.index;
        this.tran = options.tran;
        this.icons = options.icons;
        this.init();
    }
    _createClass(Template, [
        {
            key: 'init',
            value: function init() {
                this.container.innerHTML = this.tpl(this.options, this.index, this.tran, this.icons);
                this.volumeBar = this.container.querySelector('.dplayer-volume-bar-inner');
                this.volumeBarWrap = this.container.querySelector('.dplayer-volume-bar');
                this.volumeBarWrapWrap = this.container.querySelector('.dplayer-volume-bar-wrap');
                this.volumeButton = this.container.querySelector('.dplayer-volume');
                this.volumeIcon = this.container.querySelector('.dplayer-volume-icon .dplayer-icon-content');
                this.playedBar = this.container.querySelector('.dplayer-played');
                this.loadedBar = this.container.querySelector('.dplayer-loaded');
                this.playedBarWrap = this.container.querySelector('.dplayer-bar-wrap');
                this.playedBarTime = this.container.querySelector('.dplayer-bar-time');
                this.danmaku = this.container.querySelector('.dplayer-danmaku');
                this.danmakuLoading = this.container.querySelector('.dplayer-danloading');
                this.video = this.container.querySelector('.dplayer-video-current');
                this.bezel = this.container.querySelector('.dplayer-bezel-icon');
                this.playButton = this.container.querySelector('.dplayer-play-icon');
                this.videoWrap = this.container.querySelector('.dplayer-video-wrap');
                this.controllerMask = this.container.querySelector('.dplayer-controller-mask');
                this.ptime = this.container.querySelector('.dplayer-ptime');
                this.settingButton = this.container.querySelector('.dplayer-setting-icon');
                this.settingBox = this.container.querySelector('.dplayer-setting-box');
                this.mask = this.container.querySelector('.dplayer-mask');
                this.loop = this.container.querySelector('.dplayer-setting-loop');
                this.loopToggle = this.container.querySelector('.dplayer-setting-loop .dplayer-toggle-setting-input');
                this.showDanmaku = this.container.querySelector('.dplayer-setting-showdan');
                this.showDanmakuToggle = this.container.querySelector('.dplayer-showdan-setting-input');
                this.unlimitDanmaku = this.container.querySelector('.dplayer-setting-danunlimit');
                this.unlimitDanmakuToggle = this.container.querySelector('.dplayer-danunlimit-setting-input');
                this.speed = this.container.querySelector('.dplayer-setting-speed');
                this.speedItem = this.container.querySelectorAll('dplayer-setting-speed-item');
                this.danmakuOpacityBar = this.container.querySelector('.dplayer-danmaku-bar-inner');
                this.danmakuOpacityBarWrap = this.container.querySelector('.dplayer-danmaku-bar');
                this.danmakuOpacityBarWrapWrap = this.container.querySelector('.dplayer-danmaku-bar-wrap');
                this.danmakuOpacityBox = this.container.querySelector('.dplayer-setting-danmaku');
                this.dtime = this.container.querySelector('.dplayer-dtime');
                this.controller = this.container.querySelector('.dplayer-controller');
                this.commentInput = this.container.querySelector('.dplayer-comment-input');
                this.commentButton = this.container.querySelector('.dplayer-comment-icon');
                this.commentSettingBox = this.container.querySelector('.dplayer-comment-setting-box');
                this.commentSettingButton = this.container.querySelector('.dplayer-comment-setting-icon');
                this.commentSettingFill = this.container.querySelector('.dplayer-comment-setting-icon .dplayer-fill');
                this.commentSendButton = this.container.querySelector('.dplayer-send-icon');
                this.commentSendFill = this.container.querySelector('.dplayer-send-icon .dplayer-fill');
                this.commentColorSettingBox = this.container.querySelector('.dplayer-comment-setting-color');
                this.svgFill = this.container.querySelector('.dplayer-fill');
                this.browserFullButton = this.container.querySelector('.dplayer-full-icon');
                this.webFullButton = this.container.querySelector('.dplayer-full-in-icon');
                this.menu = this.container.querySelector('.dplayer-menu');
                this.qualityList = this.container.querySelector('.dplayer-quality-list');
                this.camareButton = this.container.querySelector('.dplayer-camera-icon');
                this.subtitleButton = this.container.querySelector('.dplayer-subtitle-icon');
                this.subtitleButtonInner = this.container.querySelector('.dplayer-subtitle-icon .dplayer-icon-content');
                this.subtitle = this.container.querySelector('.dplayer-subtitle');
                this.qualityButton = this.container.querySelector('.dplayer-quality-icon');
                this.videoWrap = this.parent = this.container.querySelector('.dplayer-video-wrap');
                this.barPreview = this.container.querySelector('.dplayer-bar-preview');
                this.barWrap = this.container.querySelector('.dplayer-bar-wrap');
                this.notice = this.container.querySelector('.dplayer-notice');
            }
        },
        {
            key: 'tpl',
            value: function tpl(options, index, tran, icons) {
                return '<div class="dplayer-mask"></div><div class="dplayer-video-wrap">' + this.tplVideo(true, options.video.pic, options.screenshot, options.preload, options.video.url, options.subtitle) + '' + (options.logo ? '<div class="dplayer-logo"><img src="' + options.logo + '"></div>' : '') + '<div class="dplayer-danmaku" style="' + (options.danmaku ? this.tplDanmakumargin(options.danmaku.margin) : '') + '"><div class="dplayer-danmaku-item dplayer-danmaku-item--demo"></div></div><div class="dplayer-subtitle"></div><div class="dplayer-bezel"><span class="dplayer-bezel-icon"></span>' + (options.danmaku ? '<span class="dplayer-danloading">' + tran('Danmaku is loading') + '</span>' : '') + '<span class="diplayer-loading-icon"><svg height="100%" version="1.1" viewBox="0 0 22 22" width="100%"><svg x="7" y="1"><circle class="diplayer-loading-dot diplayer-loading-dot-0" cx="4" cy="4" r="2"></circle></svg><svg x="11" y="3"><circle class="diplayer-loading-dot diplayer-loading-dot-1" cx="4" cy="4" r="2"></circle></svg><svg x="13" y="7"><circle class="diplayer-loading-dot diplayer-loading-dot-2" cx="4" cy="4" r="2"></circle></svg><svg x="11" y="11"><circle class="diplayer-loading-dot diplayer-loading-dot-3" cx="4" cy="4" r="2"></circle></svg><svg x="7" y="13"><circle class="diplayer-loading-dot diplayer-loading-dot-4" cx="4" cy="4" r="2"></circle></svg><svg x="3" y="11"><circle class="diplayer-loading-dot diplayer-loading-dot-5" cx="4" cy="4" r="2"></circle></svg><svg x="1" y="7"><circle class="diplayer-loading-dot diplayer-loading-dot-6" cx="4" cy="4" r="2"></circle></svg><svg x="3" y="3"><circle class="diplayer-loading-dot diplayer-loading-dot-7" cx="4" cy="4" r="2"></circle></svg></svg></span></div></div><div class="dplayer-controller-mask"></div><div class="dplayer-controller"><div class="dplayer-icons dplayer-comment-box"><button class="dplayer-icon dplayer-comment-setting-icon" data-balloon="' + tran('Setting') + '" data-balloon-pos="up"><span class="dplayer-icon-content">' + icons.get('pallette') + '</span></button><div class="dplayer-comment-setting-box"><div class="dplayer-comment-setting-color"><div class="dplayer-comment-setting-title">' + tran('Set danmaku color') + '</div><label><input type="radio" name="dplayer-danmaku-color-' + index + '" value="#fff" checked><span style="background: #fff;"></span></label><label><input type="radio" name="dplayer-danmaku-color-' + index + '" value="#e54256"><span style="background: #e54256"></span></label><label><input type="radio" name="dplayer-danmaku-color-' + index + '" value="#ffe133"><span style="background: #ffe133"></span></label><label><input type="radio" name="dplayer-danmaku-color-' + index + '" value="#64DD17"><span style="background: #64DD17"></span></label><label><input type="radio" name="dplayer-danmaku-color-' + index + '" value="#39ccff"><span style="background: #39ccff"></span></label><label><input type="radio" name="dplayer-danmaku-color-' + index + '" value="#D500F9"><span style="background: #D500F9"></span></label></div><div class="dplayer-comment-setting-type"><div class="dplayer-comment-setting-title">' + tran('Set danmaku type') + '</div><label><input type="radio" name="dplayer-danmaku-type-' + index + '" value="top"><span>' + tran('Top') + '</span></label><label><input type="radio" name="dplayer-danmaku-type-' + index + '" value="right" checked><span>' + tran('Rolling') + '</span></label><label><input type="radio" name="dplayer-danmaku-type-' + index + '" value="bottom"><span>' + tran('Bottom') + '</span></label></div></div><input class="dplayer-comment-input" type="text" placeholder="' + tran('Input danmaku, hit Enter') + '" maxlength="30"><button class="dplayer-icon dplayer-send-icon" data-balloon="' + tran('Send') + '" data-balloon-pos="up"><span class="dplayer-icon-content">' + icons.get('send') + '</span></button></div><div class="dplayer-icons dplayer-icons-left"><button class="dplayer-icon dplayer-play-icon"><span class="dplayer-icon-content">' + icons.get('play') + '</span></button><div class="dplayer-volume"><button class="dplayer-icon dplayer-volume-icon"><span class="dplayer-icon-content">' + icons.get('volume-down') + '</span></button><div class="dplayer-volume-bar-wrap" data-balloon-pos="up"><div class="dplayer-volume-bar"><div class="dplayer-volume-bar-inner" style="background: ' + options.theme + ';"><span class="dplayer-thumb" style="background: ' + options.theme + '"></span></div></div></div></div><span class="dplayer-time"><span class="dplayer-ptime">0:00</span> / <span class="dplayer-dtime">0:00</span></span>' + (options.live ? '<span class="dplayer-live-badge"><span class="dplayer-live-dot" style="background: ' + options.theme + ';"></span>' + tran('Live') + '</span>' : '') + '</div><div class="dplayer-icons dplayer-icons-right">' + (options.video.quality ? '<div class="dplayer-quality"><button class="dplayer-icon dplayer-quality-icon">' + options.video.quality[options.video.defaultQuality].name + '</button><div class="dplayer-quality-mask">' + this.tplQualityList(options.video.quality) + '</div></div>' : '') + '' + (options.screenshot ? '<a href="#" class="dplayer-icon dplayer-camera-icon" data-balloon="' + tran('Screenshot') + '" data-balloon-pos="up"><span class="dplayer-icon-content">' + icons.get('camera') + '</span></a>' : '') + '<div class="dplayer-comment"><button class="dplayer-icon dplayer-comment-icon" data-balloon="' + tran('Send danmaku') + '" data-balloon-pos="up"><span class="dplayer-icon-content">' + icons.get('comment') + '</span></button></div>' + (options.subtitle ? '<div class="dplayer-subtitle-btn"><button class="dplayer-icon dplayer-subtitle-icon" data-balloon="' + tran('Hide subtitle') + '" data-balloon-pos="up"><span class="dplayer-icon-content">' + icons.get('subtitle') + '</span></button></div>' : '') + '<div class="dplayer-setting"><button class="dplayer-icon dplayer-setting-icon" data-balloon="' + tran('Setting') + '" data-balloon-pos="up"><span class="dplayer-icon-content">' + icons.get('setting') + '</span></button><div class="dplayer-setting-box"><div class="dplayer-setting-origin-panel"><div class="dplayer-setting-item dplayer-setting-speed"><span class="dplayer-label">' + tran('Speed') + '</span><div class="dplayer-toggle">' + icons.get('right') + '</div></div><div class="dplayer-setting-item dplayer-setting-loop"><span class="dplayer-label">' + tran('Loop') + '</span><div class="dplayer-toggle"><input class="dplayer-toggle-setting-input" type="checkbox" name="dplayer-toggle"><label for="dplayer-toggle"></label></div></div><div class="dplayer-setting-item dplayer-setting-showdan"><span class="dplayer-label">' + tran('Show danmaku') + '</span><div class="dplayer-toggle"><input class="dplayer-showdan-setting-input" type="checkbox" name="dplayer-toggle-dan"><label for="dplayer-toggle-dan"></label></div></div><div class="dplayer-setting-item dplayer-setting-danunlimit"><span class="dplayer-label">' + tran('Unlimited danmaku') + '</span><div class="dplayer-toggle"><input class="dplayer-danunlimit-setting-input" type="checkbox" name="dplayer-toggle-danunlimit"><label for="dplayer-toggle-danunlimit"></label></div></div><div class="dplayer-setting-item dplayer-setting-danmaku"><span class="dplayer-label">' + tran('Opacity for danmaku') + '</span><div class="dplayer-danmaku-bar-wrap"><div class="dplayer-danmaku-bar"><div class="dplayer-danmaku-bar-inner"><span class="dplayer-thumb"></span></div></div></div></div></div><div class="dplayer-setting-speed-panel"><div class="dplayer-setting-speed-item" data-speed="0.5"><span class="dplayer-label">0.5</span></div><div class="dplayer-setting-speed-item" data-speed="0.75"><span class="dplayer-label">0.75</span></div><div class="dplayer-setting-speed-item" data-speed="1"><span class="dplayer-label">' + tran('Normal') + '</span></div><div class="dplayer-setting-speed-item" data-speed="1.25"><span class="dplayer-label">1.25</span></div><div class="dplayer-setting-speed-item" data-speed="1.5"><span class="dplayer-label">1.5</span></div><div class="dplayer-setting-speed-item" data-speed="2"><span class="dplayer-label">2</span></div></div></div></div><div class="dplayer-full"><button class="dplayer-icon dplayer-full-in-icon" data-balloon="' + tran('Web full screen') + '" data-balloon-pos="up"><span class="dplayer-icon-content">' + icons.get('full-in') + '</span></button><button class="dplayer-icon dplayer-full-icon" data-balloon="' + tran('Full screen') + '" data-balloon-pos="up"><span class="dplayer-icon-content">' + icons.get('full') + '</span></button></div></div><div class="dplayer-bar-wrap"><div class="dplayer-bar-time hidden">00:00</div><div class="dplayer-bar-preview"></div><div class="dplayer-bar"><div class="dplayer-loaded" style="width: 0;"></div><div class="dplayer-played" style="width: 0; background: ' + options.theme + '"><span class="dplayer-thumb" style="background: ' + options.theme + '"></span></div></div></div></div>' + this.tplContextmenuList(options.contextmenu, tran) + '<div class="dplayer-notice"></div>';
            }
        },
        {
            key: 'tplDanmakumargin',
            value: function tplDanmakumargin(margin) {
                var result = '';
                if (margin) {
                    for (var key in margin) {
                        result += key + ':' + margin[key] + ';';
                    }
                }
                return result;
            }
        },
        {
            key: 'tplContextmenuList',
            value: function tplContextmenuList(contextmenu, tran) {
                var result = '<div class="dplayer-menu">';
                for (var i = 0; i < contextmenu.length; i++) {
                    result += '<div class="dplayer-menu-item"><a target="_blank" href="' + contextmenu[i].link + '">' + tran(contextmenu[i].text) + '</a></div>';
                }
                result += '</div>';
                return result;
            }
        },
        {
            key: 'tplQualityList',
            value: function tplQualityList(quality) {
                var result = '<div class="dplayer-quality-list">';
                for (var i = 0; i < quality.length; i++) {
                    result += '<div class="dplayer-quality-item" data-index="' + i + '">' + quality[i].name + '</div>';
                }
                result += '</div>';
                return result;
            }
        },
        {
            key: 'tplVideo',
            value: function tplVideo(current, pic, screenshot, preload, url, subtitle) {
                var enableSubtitle = subtitle && subtitle.type === 'webvtt';
                return '<video class="dplayer-video ' + (current ? 'dplayer-video-current"' : '') + '" ' + (pic ? 'poster="' + pic + '"' : '') + ' webkit-playsinline playsinline ' + (screenshot || enableSubtitle ? 'crossorigin="anonymous"' : '') + ' ' + (preload ? 'preload="' + preload + '"' : '') + ' src="' + url + '">' + (enableSubtitle ? '<track kind="metadata" default src="' + subtitle.url + '"></track>' : '') + '</video>';
            }
        }
    ]);
    return Template;
}();
module.exports = Template;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor)
                descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
var SvgSource = function () {
    function SvgSource(options) {
        _classCallCheck(this, SvgSource);
        this.icons = options.icons;
        this.iconColor = options.iconsColor;
    }
    _createClass(SvgSource, [{
            key: 'get',
            value: function get(type) {
                return '<svg xmlns="http://www.w3.org/2000/svg" width="' + (this.icons[type][2] || '100%') + '" height="' + (this.icons[type][2] || '100%') + '" version="1.1" viewBox="' + this.icons[type][0] + '"><path class="dplayer-fill" style="fill:' + this.iconColor + '" d="' + this.icons[type][1] + '" id="dplayer-' + type + '"></path></svg>';
            }
        }]);
    return SvgSource;
}();
module.exports = SvgSource;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _typeof = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? function (obj) {
    return typeof obj;
} : function (obj) {
    return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
};
var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor)
                descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
var Danmaku = function () {
    function Danmaku(options) {
        _classCallCheck(this, Danmaku);
        this.options = options;
        this.container = this.options.container;
        this.danTunnel = {
            right: {},
            top: {},
            bottom: {}
        };
        this.danIndex = 0;
        this.dan = [];
        this.showing = true;
        this._opacity = this.options.opacity;
        this.events = this.options.events;
        this.unlimited = this.options.unlimited;
        this._measure('');
        this.load();
    }
    _createClass(Danmaku, [
        {
            key: 'load',
            value: function load() {
                var _this = this;
                var apiurl = void 0;
                if (this.options.api.maximum) {
                    apiurl = this.options.api.address + '?id=' + this.options.api.id + '&max=' + this.options.api.maximum;
                } else {
                    apiurl = this.options.api.address + '?id=' + this.options.api.id;
                }
                var endpoints = (this.options.api.addition || []).slice(0);
                endpoints.push(apiurl);
                this.events && this.events.trigger('danmaku_load_start', endpoints);
                this._readAllEndpoints(endpoints, function (results) {
                    _this.dan = [].concat.apply([], results).sort(function (a, b) {
                        return a.time - b.time;
                    });
                    window.requestAnimationFrame(function () {
                        _this.frame();
                    });
                    _this.options.callback();
                    _this.events && _this.events.trigger('danmaku_load_end');
                });
            }
        },
        {
            key: 'reload',
            value: function reload(newAPI) {
                this.options.api = newAPI;
                this.dan = [];
                this.clear();
                this.load();
            }
        },
        {
            key: '_readAllEndpoints',
            value: function _readAllEndpoints(endpoints, callback) {
                var _this2 = this;
                var results = [];
                var readCount = 0;
                var cbk = function cbk(i) {
                    return function (err, data) {
                        ++readCount;
                        if (err) {
                            if (err.response) {
                                _this2.options.error(err.response.msg);
                            } else {
                                _this2.options.error('Request was unsuccessful: ' + err.status);
                            }
                            results[i] = [];
                        } else {
                            results[i] = data;
                        }
                        if (readCount === endpoints.length) {
                            return callback(results);
                        }
                    };
                };
                for (var i = 0; i < endpoints.length; ++i) {
                    this.options.apiBackend.read(endpoints[i], cbk(i));
                }
            }
        },
        {
            key: 'send',
            value: function send(dan, callback) {
                var danmakuData = {
                    token: this.options.api.token,
                    player: this.options.api.id,
                    author: this.options.api.user,
                    time: this.options.time(),
                    text: dan.text,
                    color: dan.color,
                    type: dan.type
                };
                this.options.apiBackend.send(this.options.api.address, danmakuData, callback);
                this.dan.splice(this.danIndex, 0, danmakuData);
                this.danIndex++;
                var danmaku = {
                    text: this.htmlEncode(danmakuData.text),
                    color: danmakuData.color,
                    type: danmakuData.type,
                    border: '2px solid ' + this.options.borderColor
                };
                this.draw(danmaku);
                this.events && this.events.trigger('danmaku_send', danmakuData);
            }
        },
        {
            key: 'frame',
            value: function frame() {
                var _this3 = this;
                if (this.dan.length && !this.paused && this.showing) {
                    var item = this.dan[this.danIndex];
                    var dan = [];
                    while (item && this.options.time() > parseFloat(item.time)) {
                        dan.push(item);
                        item = this.dan[++this.danIndex];
                    }
                    this.draw(dan);
                }
                window.requestAnimationFrame(function () {
                    _this3.frame();
                });
            }
        },
        {
            key: 'opacity',
            value: function opacity(percentage) {
                if (percentage !== undefined) {
                    var items = this.container.getElementsByClassName('dplayer-danmaku-item');
                    for (var i = 0; i < items.length; i++) {
                        items[i].style.opacity = percentage;
                    }
                    this._opacity = percentage;
                    this.events && this.events.trigger('danmaku_opacity', this._opacity);
                }
                return this._opacity;
            }
        },
        {
            key: 'draw',
            value: function draw(dan) {
                var _this4 = this;
                if (this.showing) {
                    var itemHeight = this.options.height;
                    var danWidth = this.container.offsetWidth;
                    var danHeight = this.container.offsetHeight;
                    var itemY = parseInt(danHeight / itemHeight);
                    var danItemRight = function danItemRight(ele) {
                        var eleWidth = ele.offsetWidth || parseInt(ele.style.width);
                        var eleRight = ele.getBoundingClientRect().right || _this4.container.getBoundingClientRect().right + eleWidth;
                        return _this4.container.getBoundingClientRect().right - eleRight;
                    };
                    var danSpeed = function danSpeed(width) {
                        return (danWidth + width) / 5;
                    };
                    var getTunnel = function getTunnel(ele, type, width) {
                        var tmp = danWidth / danSpeed(width);
                        var _loop = function _loop(i) {
                            var item = _this4.danTunnel[type][i + ''];
                            if (item && item.length) {
                                if (type !== 'right') {
                                    return 'continue';
                                }
                                for (var j = 0; j < item.length; j++) {
                                    var danRight = danItemRight(item[j]) - 10;
                                    if (danRight <= danWidth - tmp * danSpeed(parseInt(item[j].style.width)) || danRight <= 0) {
                                        break;
                                    }
                                    if (j === item.length - 1) {
                                        _this4.danTunnel[type][i + ''].push(ele);
                                        ele.addEventListener('animationend', function () {
                                            _this4.danTunnel[type][i + ''].splice(0, 1);
                                        });
                                        return { v: i % itemY };
                                    }
                                }
                            } else {
                                _this4.danTunnel[type][i + ''] = [ele];
                                ele.addEventListener('animationend', function () {
                                    _this4.danTunnel[type][i + ''].splice(0, 1);
                                });
                                return { v: i % itemY };
                            }
                        };
                        for (var i = 0; _this4.unlimited || i < itemY; i++) {
                            var _ret = _loop(i);
                            switch (_ret) {
                            case 'continue':
                                continue;
                            default:
                                if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === 'object')
                                    return _ret.v;
                            }
                        }
                        return -1;
                    };
                    if (Object.prototype.toString.call(dan) !== '[object Array]') {
                        dan = [dan];
                    }
                    var docFragment = document.createDocumentFragment();
                    var _loop2 = function _loop2(i) {
                        if (!dan[i].type) {
                            dan[i].type = 'right';
                        }
                        if (!dan[i].color) {
                            dan[i].color = '#fff';
                        }
                        var item = document.createElement('div');
                        item.classList.add('dplayer-danmaku-item');
                        item.classList.add('dplayer-danmaku-' + dan[i].type);
                        if (dan[i].border) {
                            item.innerHTML = '<span style="border:' + dan[i].border + '">' + dan[i].text + '</span>';
                        } else {
                            item.innerHTML = dan[i].text;
                        }
                        item.style.opacity = _this4._opacity;
                        item.style.color = dan[i].color;
                        item.addEventListener('animationend', function () {
                            _this4.container.removeChild(item);
                        });
                        var itemWidth = _this4._measure(dan[i].text);
                        var tunnel = void 0;
                        switch (dan[i].type) {
                        case 'right':
                            tunnel = getTunnel(item, dan[i].type, itemWidth);
                            if (tunnel >= 0) {
                                item.style.width = itemWidth + 1 + 'px';
                                item.style.top = itemHeight * tunnel + 'px';
                                item.style.transform = 'translateX(-' + danWidth + 'px)';
                            }
                            break;
                        case 'top':
                            tunnel = getTunnel(item, dan[i].type);
                            if (tunnel >= 0) {
                                item.style.top = itemHeight * tunnel + 'px';
                            }
                            break;
                        case 'bottom':
                            tunnel = getTunnel(item, dan[i].type);
                            if (tunnel >= 0) {
                                item.style.bottom = itemHeight * tunnel + 'px';
                            }
                            break;
                        default:
                            console.error('Can\'t handled danmaku type: ' + dan[i].type);
                        }
                        if (tunnel >= 0) {
                            item.classList.add('dplayer-danmaku-move');
                            docFragment.appendChild(item);
                        }
                    };
                    for (var i = 0; i < dan.length; i++) {
                        _loop2(i);
                    }
                    this.container.appendChild(docFragment);
                    return docFragment;
                }
            }
        },
        {
            key: 'play',
            value: function play() {
                this.paused = false;
            }
        },
        {
            key: 'pause',
            value: function pause() {
                this.paused = true;
            }
        },
        {
            key: '_measure',
            value: function _measure(text) {
                if (!this.context) {
                    var measureStyle = getComputedStyle(this.container.getElementsByClassName('dplayer-danmaku-item')[0], null);
                    this.context = document.createElement('canvas').getContext('2d');
                    this.context.font = measureStyle.getPropertyValue('font');
                }
                return this.context.measureText(text).width;
            }
        },
        {
            key: 'seek',
            value: function seek() {
                this.clear();
                for (var i = 0; i < this.dan.length; i++) {
                    if (this.dan[i].time >= this.options.time()) {
                        this.danIndex = i;
                        break;
                    }
                    this.danIndex = this.dan.length;
                }
            }
        },
        {
            key: 'clear',
            value: function clear() {
                this.danTunnel = {
                    right: {},
                    top: {},
                    bottom: {}
                };
                this.danIndex = 0;
                this.options.container.innerHTML = '';
                this.events && this.events.trigger('danmaku_clear');
            }
        },
        {
            key: 'htmlEncode',
            value: function htmlEncode(str) {
                return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;').replace(/\//g, '&#x2f;');
            }
        },
        {
            key: 'resize',
            value: function resize() {
                var danWidth = this.container.offsetWidth;
                var items = this.container.getElementsByClassName('dplayer-danmaku-item');
                for (var i = 0; i < items.length; i++) {
                    items[i].style.transform = 'translateX(-' + danWidth + 'px)';
                }
            }
        },
        {
            key: 'hide',
            value: function hide() {
                this.showing = false;
                this.pause();
                this.clear();
                this.events && this.events.trigger('danmaku_hide');
            }
        },
        {
            key: 'show',
            value: function show() {
                this.seek();
                this.showing = true;
                this.play();
                this.events && this.events.trigger('danmaku_show');
            }
        },
        {
            key: 'unlimit',
            value: function unlimit(boolean) {
                this.unlimited = boolean;
            }
        }
    ]);
    return Danmaku;
}();
module.exports = Danmaku;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor)
                descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
var Thumbnails = function () {
    function Thumbnails(container, width, url, events) {
        _classCallCheck(this, Thumbnails);
        this.container = container;
        this.width = width;
        this.container.style.backgroundImage = 'url(\'' + url + '\')';
        this.events = events;
    }
    _createClass(Thumbnails, [
        {
            key: 'resize',
            value: function resize(width, height) {
                this.container.style.width = width + 'px';
                this.container.style.height = height + 'px';
                this.container.style.top = -height + 2 + 'px';
            }
        },
        {
            key: 'show',
            value: function show() {
                this.container.style.display = 'block';
                this.events && this.events.trigger('thumbnails_show');
            }
        },
        {
            key: 'move',
            value: function move(position) {
                this.container.style.backgroundPosition = '-' + (Math.ceil(position / this.width * 100) - 1) * 160 + 'px 0';
                this.container.style.left = position - this.container.offsetWidth / 2 + 'px';
            }
        },
        {
            key: 'hide',
            value: function hide() {
                this.container.style.display = 'none';
                this.events && this.events.trigger('thumbnails_hide');
            }
        }
    ]);
    return Thumbnails;
}();
module.exports = Thumbnails;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor)
                descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
var Events = function () {
    function Events() {
        _classCallCheck(this, Events);
        this.events = {};
        this.videoEvents = [
            'abort',
            'canplay',
            'canplaythrough',
            'durationchange',
            'emptied',
            'ended',
            'error',
            'loadeddata',
            'loadedmetadata',
            'loadstart',
            'mozaudioavailable',
            'pause',
            'play',
            'playing',
            'progress',
            'ratechange',
            'seeked',
            'seeking',
            'stalled',
            'suspend',
            'timeupdate',
            'volumechange',
            'waiting'
        ];
        this.playerEvents = [
            'screenshot',
            'thumbnails_show',
            'thumbnails_hide',
            'danmaku_show',
            'danmaku_hide',
            'danmaku_clear',
            'danmaku_loaded',
            'danmaku_send',
            'danmaku_opacity',
            'contextmenu_show',
            'contextmenu_hide',
            'notice_show',
            'notice_hide',
            'quality_start',
            'quality_end',
            'destroy',
            'resize',
            'fullscreen',
            'fullscreen_cancel',
            'webfullscreen',
            'webfullscreen_cancel',
            'subtitle_show',
            'subtitle_hide',
            'subtitle_change'
        ];
    }
    _createClass(Events, [
        {
            key: 'on',
            value: function on(name, callback) {
                if (this.type(name) && typeof callback === 'function') {
                    if (!this.events[name]) {
                        this.events[name] = [];
                    }
                    this.events[name].push(callback);
                }
            }
        },
        {
            key: 'trigger',
            value: function trigger(name, info) {
                if (this.events[name] && this.events[name].length) {
                    for (var i = 0; i < this.events[name].length; i++) {
                        this.events[name][i](info);
                    }
                }
            }
        },
        {
            key: 'type',
            value: function type(name) {
                if (this.playerEvents.indexOf(name) !== -1) {
                    return 'player';
                } else if (this.videoEvents.indexOf(name) !== -1) {
                    return 'video';
                }
                console.error('Unknown event name: ' + name);
                return null;
            }
        }
    ]);
    return Events;
}();
module.exports = Events;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor)
                descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _utils = __webpack_require__(0);
var _utils2 = _interopRequireDefault(_utils);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
var FullScreen = function () {
    function FullScreen(player) {
        var _this = this;
        _classCallCheck(this, FullScreen);
        this.player = player;
        this.player.events.on('webfullscreen', function () {
            _this.player.resize();
        });
        this.player.events.on('webfullscreen_cancel', function () {
            _this.player.resize();
        });
        var fullscreenchange = function fullscreenchange() {
            _this.player.resize();
            if (_this.isFullScreen('browser')) {
                _this.player.events.trigger('fullscreen');
            } else {
                _this.player.events.trigger('fullscreen_cancel');
            }
        };
        this.player.container.addEventListener('fullscreenchange', fullscreenchange);
        this.player.container.addEventListener('mozfullscreenchange', fullscreenchange);
        this.player.container.addEventListener('webkitfullscreenchange', fullscreenchange);
    }
    _createClass(FullScreen, [
        {
            key: 'isFullScreen',
            value: function isFullScreen() {
                var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'browser';
                switch (type) {
                case 'browser':
                    return document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;
                case 'web':
                    return this.player.container.classList.contains('dplayer-fulled');
                }
            }
        },
        {
            key: 'request',
            value: function request() {
                var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'browser';
                switch (type) {
                case 'browser':
                    if (this.player.container.requestFullscreen) {
                        this.player.container.requestFullscreen();
                    } else if (this.player.container.mozRequestFullScreen) {
                        this.player.container.mozRequestFullScreen();
                    } else if (this.player.container.webkitRequestFullscreen) {
                        this.player.container.webkitRequestFullscreen();
                    } else if (this.player.video.webkitEnterFullscreen) {
                        this.player.video.webkitEnterFullscreen();
                    }
                    break;
                case 'web':
                    this.player.container.classList.add('dplayer-fulled');
                    this.lastScrollPosition = _utils2.default.getScrollPosition();
                    document.body.classList.add('dplayer-web-fullscreen-fix');
                    this.player.events.trigger('webfullscreen');
                    break;
                }
            }
        },
        {
            key: 'cancel',
            value: function cancel() {
                var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'browser';
                switch (type) {
                case 'browser':
                    if (document.cancelFullScreen) {
                        document.cancelFullScreen();
                    } else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    } else if (document.webkitCancelFullScreen) {
                        document.webkitCancelFullScreen();
                    }
                    break;
                case 'web':
                    this.player.container.classList.remove('dplayer-fulled');
                    document.body.classList.remove('dplayer-web-fullscreen-fix');
                    _utils2.default.setScrollPosition(this.lastScrollPosition);
                    this.player.events.trigger('webfullscreen_cancel');
                    break;
                }
            }
        },
        {
            key: 'toggle',
            value: function toggle() {
                var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'browser';
                if (this.isFullScreen(type)) {
                    this.cancel(type);
                } else {
                    this.request(type);
                }
            }
        }
    ]);
    return FullScreen;
}();
module.exports = FullScreen;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor)
                descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _utils = __webpack_require__(0);
var _utils2 = _interopRequireDefault(_utils);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
var User = function () {
    function User(player) {
        _classCallCheck(this, User);
        this.storageName = {
            opacity: 'dplayer-danmaku-opacity',
            volume: 'dplayer-volume',
            unlimited: 'dplayer-danmaku-unlimited',
            danmaku: 'dplayer-danmaku-show',
            subtitle: 'dplayer-subtitle-show'
        };
        this.default = {
            opacity: 0.7,
            volume: player.options.volume || 0.7,
            unlimited: (player.options.danmaku && player.options.danmaku.unlimited ? 1 : 0) || 0,
            danmaku: 1,
            subtitle: 1
        };
        this.data = {};
        this.init();
    }
    _createClass(User, [
        {
            key: 'init',
            value: function init() {
                for (var item in this.storageName) {
                    var name = this.storageName[item];
                    this.data[item] = parseFloat(_utils2.default.storage.get(name) || this.default[item]);
                }
            }
        },
        {
            key: 'get',
            value: function get(key) {
                return this.data[key];
            }
        },
        {
            key: 'set',
            value: function set(key, value) {
                this.data[key] = value;
                _utils2.default.storage.set(this.storageName[key], value);
            }
        }
    ]);
    return User;
}();
module.exports = User;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor)
                descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
var Subtitle = function () {
    function Subtitle(container, video, options, events) {
        _classCallCheck(this, Subtitle);
        this.container = container;
        this.video = video;
        this.options = options;
        this.events = events;
        this.init();
    }
    _createClass(Subtitle, [
        {
            key: 'init',
            value: function init() {
                var _this = this;
                this.container.style.fontSize = this.options.fontSize;
                this.container.style.bottom = this.options.bottom;
                this.container.style.color = this.options.color;
                if (this.video.textTracks && this.video.textTracks[0]) {
                    var track = this.video.textTracks[0];
                    track.oncuechange = function () {
                        var cue = track.activeCues[0];
                        if (cue) {
                            _this.container.innerHTML = '';
                            var p = document.createElement('p');
                            p.appendChild(cue.getCueAsHTML());
                            _this.container.appendChild(p);
                        } else {
                            _this.container.innerHTML = '';
                        }
                        _this.events.trigger('subtitle_change');
                    };
                }
            }
        },
        {
            key: 'show',
            value: function show() {
                this.container.classList.remove('dplayer-subtitle-hide');
                this.events.trigger('subtitle_show');
            }
        },
        {
            key: 'hide',
            value: function hide() {
                this.container.classList.add('dplayer-subtitle-hide');
                this.events.trigger('subtitle_hide');
            }
        },
        {
            key: 'toggle',
            value: function toggle() {
                if (this.container.classList.contains('dplayer-subtitle-hide')) {
                    this.show();
                } else {
                    this.hide();
                }
            }
        }
    ]);
    return Subtitle;
}();
module.exports = Subtitle;

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// DPlayer.min.js